//Built-In
import React from 'react';

//External
import { Col} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTrash} from "@fortawesome/free-solid-svg-icons/faTrash";
import {faPlus} from "@fortawesome/free-solid-svg-icons";
import { Modal, ModalBody } from "reactstrap";
import Select from "react-select";
import cx from "classnames";
import {faChevronDown} from "@fortawesome/free-solid-svg-icons/faChevronDown";

//Internal
import requestApi from "../../services/requestApi.service";
import CampaignOperations from "../Campaigns/CampaignOperations";
import AnalyticsContent from "../Campaigns/AnalyticsContent";
import { showToast,handleErrorResponse } from '../../Common/Appcommon';

class CampaignList extends React.Component{
    delayValueName = "";
    delayTypeName = "";
    durationOptions = [];
    constructor(props) {
        super(props);
        let count = props.number;
        let campaign = props.campaign;
        this.delayValueName = "delay_duration_"+count;
        this.delayTypeName = "delay_type_"+count;
        this.durationOptions.push({
            value: "immediate", label: "Immediately"
        });
        this.durationOptions.push({
            value: "mins", label: "Mins"
        });
        this.durationOptions.push({
            value: "hrs", label: "Hours"
        });
        this.durationOptions.push({
            value: "days", label: "Days"
        });
        let defaultDuration = this.durationOptions[0];
        let campaignData = {};
        if(Object.keys(campaign).length > 0 && campaign['Message_Delay'] !== "" && campaign['Delay_Duration'] !== ""){
            campaignData[this.delayValueName] = campaign['Delay_Duration'];
            campaignData[this.delayTypeName] = campaign['Message_Delay'];
            if(campaign['Message_Delay'] === "mins"){
                defaultDuration = this.durationOptions[1];
            } else if(campaign['Message_Delay'] === "hrs"){
                defaultDuration = this.durationOptions[2];
            } else if(campaign['Message_Delay'] === "days"){
                defaultDuration = this.durationOptions[3];
            }
        }
        this.state = {
            isCampaignModal: false,
            campaignId : Object.keys(campaign).length > 0 ? campaign['id'] : "",
            defaultDuration : defaultDuration,
            conditionData : campaignData,
            campAnalytics : {},
            isOnChange : false,
        };
        this.toggleCampaignModal = this.toggleCampaignModal.bind(this);
    }

    toggleCampaignAnalytics = async(e,campaignId) => {
        e.preventDefault();
        let campAnalytics = this.state.campAnalytics;
        if(campAnalytics[campaignId]){
            delete campAnalytics[campaignId];
        } else {
            campAnalytics[campaignId] = campaignId;
        }
        this.setState({
            campAnalytics
        })
    }

    toggleCampaignModal() {
        if(this.props.selectedFormName !== ''){
            this.props.campaignModalState(!this.state.isCampaignModal);
            this.setState({
                isCampaignModal: !this.state.isCampaignModal,
            });
        }else{
            showToast("Please Select a Form","top-right","warning");
        }
    }

    campaignSaveOperation = async(campaignId) =>{
        await this.toggleCampaignModal();
        await this.props.getNewCampaignIdList(campaignId);
    }

    enableEditCampaign = async(campaignId) => {
        await this.setState({
            campaignId
        });
        this.toggleCampaignModal();
    }

    conditionTypeChange = async(selected, delayTypeName) =>{
        let conditionData = this.state.conditionData;
        let condition_split = delayTypeName.split("_");
        let delay_duration = "delay_duration_"+condition_split[2];
        conditionData[delayTypeName] = selected.value;
        conditionData[delay_duration] = conditionData[delay_duration];
        this.setState({
            defaultDuration : selected,
            conditionData : conditionData,
            isOnChange : true,
        })
        await this.updateCampaignConditionDelay();
    }

    delayConditionChange = async(e) =>{
        let name = e.target.name;
        let value = e.target.value;
        let conditionData = this.state.conditionData;
        let condition_split = name.split("_");
        let delay_type = "delay_type_"+condition_split[2];
        conditionData[name] = value;
        conditionData[delay_type] = conditionData[delay_type];
        this.setState({
            conditionData : conditionData,
            isOnChange : true
        })
        await this.updateCampaignConditionDelay();
    }

    updateCampaignConditionDelay = async() => {
        let conditionData = this.state.conditionData;
        let campaignId = this.props.campaignId;
        if(campaignId !== "" && ((conditionData[this.delayTypeName] === "immediate") || (conditionData[this.delayValueName] !== undefined && conditionData[this.delayTypeName] !== undefined))){
            let params = {
                "ENTITY": "WHATSAPPPROCESS",
                "OPERATION" : "update_delay",
                "campaignId" : campaignId,
                "isOtherApiReq" : true,
                "conditionData" : conditionData,
                "count" : this.props.number
            }
            let res = await requestApi.processServerRequest(params,"WebV2","post");
            if(res.issuccess){

            }else{
                handleErrorResponse(res.errormsg);
            }
        }
    }

    render(){
        let campaign = this.props.campaign;
        let delayValue = "";
        if(campaign === undefined){
            return (
                <div></div>
            )
        }
        if(Object.keys(campaign).length > 0 && Object.keys(this.state.conditionData).length > 0){
            delayValue = this.state.conditionData[this.delayValueName];
        }
        let defaultDuration = this.state.defaultDuration;
        let campaignData = {};
        if(Object.keys(campaign).length > 0 && !this.state.isOnChange && campaign['Message_Delay'] !== "" && campaign['Delay_Duration'] !== ""){
            campaignData[this.delayValueName] = campaign['Delay_Duration'];
            campaignData[this.delayTypeName] = campaign['Message_Delay'];
            if(campaign['Message_Delay'] === "mins"){
                defaultDuration = this.durationOptions[1];
            } else if(campaign['Message_Delay'] === "hrs"){
                defaultDuration = this.durationOptions[2];
            } else if(campaign['Message_Delay'] === "days"){
                defaultDuration = this.durationOptions[3];
            }
        }
        if(delayValue === "" && Object.keys(campaign).length > 0 && Object.keys(campaignData).length > 0){
            delayValue = campaignData[this.delayValueName];
        }
        this.state.isOnChange = false;
        let { useCForm, controller } = this.props;

        return (
            <div className={'campaigns-content'}>
                {
                    campaign !== undefined && <Modal isOpen={this.state.isCampaignModal} toggle={this.toggleCampaignModal}
                                                     className={'le-modal-lg campaign-modal'}>
                        <ModalBody>
                            <CampaignOperations
                                closeModal={this.toggleCampaignModal}
                                automationId={this.props.automationId}
                                campaignSaveOperation={this.campaignSaveOperation}
                                campaignId={this.props.campaignId}
                                isModal={true}
                                useForm={useCForm}
                                controller={controller}
                                selectedFormName={this.props.selectedFormName}
                                resetAllCampVariables={this.props.resetAllCampVariables}
                                handleCampaignChanged={this.props.handleCampaignChanged}
                            />
                        </ModalBody>
                    </Modal>
                }
                <div className={cx('campaign-action', {'messagebox-empty' : !this.props.isValidCampaign})}>
                    <div className={'d-flex-alone'}>
                        <div className={cx('campaign-action-number hide',{'' : this.props.number === 0})}>
                            <span>{this.props.number + 1}</span>
                        </div>
                        <Col md={"10"} className={'align-center'}>
                            {
                                Object.keys(campaign).length > 0 ?
                                    <div className={'d-flex-alone col-md-12'}>
                                        <div className={cx('col-md-9 display-align-center')}>
                                            <div className={cx('automation-campaign-link cursor-p')} onClick={(e) => {this.enableEditCampaign(campaign['id'])}}>
                                                {campaign['Name']}
                                            </div>
                                        </div>
                                        <div className={cx('delay-condition col-md-3 mt-2 mb-2 d-flex-alone',) }>
                                            <div className={'w-100'}>
                                                <div className={cx('w-100 d-flex-alone condition-block justify-content-right',{'d-flex-alone ' : defaultDuration.value !== "immediate"})}>
                                                    {
                                                        defaultDuration.value !== "immediate" /*&& delayValue !== ""*/ &&
                                                        <input value={delayValue} type={"text"} name={this.delayValueName}
                                                               placeholder={'xx'} onChange={(e) => {
                                                            this.delayConditionChange(e)
                                                        }} className={cx('form-control delay-box col-md-1')} required={true}/>
                                                    }
                                                    <Select name="delay-condition" className={"condition-block-select"} classNamePrefix="wa-select" id={`delay-condition-select ${defaultDuration.value === "immediate" ? 'immediate-width' : ''}`} value={defaultDuration} onChange={(e) => (this.conditionTypeChange(e, this.delayTypeName))} options={this.durationOptions}/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    : <div
                                        onClick={this.toggleCampaignModal}
                                        className={
                                            cx("col-md-3 task-name text-truncate cursor-p",
                                                {"disabled-area" : this.props.selectedFormName === ''})}>
                                        Create Message
                                    </div>
                            }

                        </Col>
                        <Col md={'2'} className={cx('campaign-action-buttons',{'' : this.props.number === 0})}>
                            <div className={'form-group'}>
                                <div className={'form-row-action-buttons'}>
                                    <FontAwesomeIcon icon={faTrash} onClick={(e) => {this.props.removeCampaign(this.props.campaignId)}} />
                                    {
                                        campaign['id'] !== "" && <FontAwesomeIcon icon={faChevronDown} onClick={(e) => {this.toggleCampaignAnalytics(e,campaign['id'])}} />
                                    }
                                    {
                                        this.props.isLastCampaign && <FontAwesomeIcon onClick={(e) => {this.props.incrementCampaignCount(e)}} icon={faPlus} />
                                    }

                                </div>
                            </div>
                        </Col>

                    </div>
                    {
                        this.props.campaignId !== "" &&
                        <div className={cx('border-primary brt-1 mt-1 pt-3', {'hide': this.state.campAnalytics[this.props.campaignId] === undefined})}>
                            <AnalyticsContent totalCount={campaign['TotalCount']} sentCount={campaign['sentCount']} deliveredCount={campaign['deliveredCount']} ReadCount={campaign['ReadCount']} repliedCount={campaign['RepliedCount']} viewLink={"#/deliverylog/messages/"+campaign['id']} formId={campaign['id']} />
                        </div>
                    }
                </div>
            </div>

        )
    }
}
export default CampaignList;